import { LoadableAfterPaint } from '@confluence/loadable';

// @todo CTE-214 work with Chan to define loading state for overall component
export const TemplatePanel = LoadableAfterPaint({
	loader: async () =>
		(await import(/* webpackChunkName: "loadable-TemplatePanel" */ './TemplatePanel'))
			.TemplatePanel,
});
